import { render, staticRenderFns } from "./PageHeaderLogoMobile.vue?vue&type=template&id=61b0e2eb&scoped=true&"
import script from "./PageHeaderLogoMobile.vue?vue&type=script&lang=js&"
export * from "./PageHeaderLogoMobile.vue?vue&type=script&lang=js&"
import style0 from "./PageHeaderLogoMobile.vue?vue&type=style&index=0&id=61b0e2eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b0e2eb",
  null
  
)

export default component.exports